'use client'

import { usePathname, useSearchParams } from 'next/navigation'

type ParamChanges = Record<string, string | string[] | number | null>

export const useQueryParams = () => {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const getParam = (key: string) => {
    return searchParams?.get(key) || ''
  }

  const getLinkWith = (changes: ParamChanges) => {
    const params = new URLSearchParams(searchParams?.toString() || '')

    for (const [key, value] of Object.entries(changes)) {
      if (value === null) {
        params.delete(key)
      } else {
        if (Array.isArray(value)) {
          params.set(key, value.join(','))
        } else {
          params.set(key, value.toString())
        }
      }
    }

    const queryString = params.toString()
    return queryString ? `${pathname}?${queryString}` : pathname || ''
  }

  return { getLinkWith, get: getParam }
}
